export enum ToolbarState {
  Search = 'search',
}
